import React from 'react';
import Icon from '../../../components/AppIcon';

const MissionSection: React.FC = () => {
  return (
    <section className="py-20 lg:py-28 bg-surface border-y border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {/* Left: Content */}
          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-1.5 rounded-full mb-8">
              <Icon name="Target" size={16} />
              <span className="text-sm font-bold uppercase tracking-wide">Our Mission</span>
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6 leading-tight">
              Automation That <br />
              <span className="text-primary">Actually Thinks</span>
            </h2>
            
            <p className="text-lg text-text-secondary mb-6 leading-relaxed">
              At Make Mind Automations, we don't just connect API endpoints. We engineer 
              <span className="font-semibold text-text-primary"> intelligent ecosystems</span>.
            </p>
            
            <p className="text-lg text-text-secondary mb-8 leading-relaxed">
              Our mission is to liberate business owners from the "Admin Trap." We believe that humans should focus on strategy, creativity, and relationships, while our robots handle the data entry, scheduling, and follow-ups.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center space-x-3 p-4 bg-background rounded-xl border border-border shadow-sm">
                <div className="p-2 bg-accent/10 rounded-lg text-accent">
                  <Icon name="Zap" size={20} />
                </div>
                <div>
                  <h4 className="font-bold text-text-primary">Speed</h4>
                  <p className="text-xs text-text-secondary">Execution in milliseconds</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3 p-4 bg-background rounded-xl border border-border shadow-sm">
                <div className="p-2 bg-success/10 rounded-lg text-success">
                  <Icon name="TrendingUp" size={20} />
                </div>
                <div>
                  <h4 className="font-bold text-text-primary">Growth</h4>
                  <p className="text-xs text-text-secondary">Scale without headcount</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="order-1 lg:order-2 relative">
            {/* Main Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-border/50 group">
              <div className="absolute inset-0 bg-primary/10 group-hover:bg-transparent transition-colors duration-500 z-10" />
              <img 
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80" 
                alt="Team working on automation strategy" 
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              
              {/* Floating Stat Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-background/90 backdrop-blur-md p-6 rounded-xl border border-border shadow-lg z-20">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-primary rounded-lg text-white">
                    <Icon name="Lightbulb" size={24} />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-text-primary">The Automation Standard</h3>
                    <p className="text-sm text-text-secondary mt-1">
                      "We build systems that are robust enough for enterprise, but agile enough for startups."
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Background Elements */}
            <div className="absolute -top-10 -right-10 w-32 h-32 bg-accent/20 rounded-full blur-3xl -z-10" />
            <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-primary/20 rounded-full blur-3xl -z-10" />
          </div>

        </div>
      </div>
    </section>
  );
};

export default MissionSection;